module.exports = __webpack_public_path__ + "img/icon-wrapper.c43136ca.png";